import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const Warehouses = () => {
  return (
    <div 
      className="min-h-screen py-8 px-4"
      style={{
        background: `
          radial-gradient(900px 600px at 10% 10%, #132552 0%, #0B1736 45%, #060f24 100%)
        `
      }}
    >
      <main className="max-w-7xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 mt-2">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Button>
        </Link>

        <div className="border border-[hsl(var(--line))] rounded-[14px] p-4 sm:p-6 md:p-12" style={{ boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)" }}>
          <h1 className="font-orbitron font-bold text-3xl sm:text-4xl md:text-5xl mb-6 leading-tight">
            Warehouse <span className="text-primary">Automation</span>
          </h1>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">The Challenge</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-4 leading-relaxed">
              Warehouses and distribution centers need spotless, safe floors to prevent accidents and meet OSHA standards. Manual cleaning is expensive, time-consuming, and pulls staff from high-value tasks.
            </p>
          </section>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">The Solution</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-6 leading-relaxed">
              Our Warehouse Bundle uses PUDU T600 and CC1 Pro robots to handle floor cleaning across massive facilities, plus AI Voice for dispatch and vendor communication.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">PUDU T600</h3>
                <p className="text-sm text-muted-foreground">Heavy-payload industrial delivery robot with 600kg capacity for material transport</p>
                <p className="text-primary font-bold mt-2 text-sm">600kg capacity • 12hr battery</p>
              </div>
              
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">CC1 Pro</h3>
                <p className="text-sm text-muted-foreground">Autonomous cleaning for office areas and break rooms</p>
                <p className="text-primary font-bold mt-2 text-sm">Scheduled cleaning</p>
              </div>
              
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">AI Voice Dispatch</h3>
                <p className="text-sm text-muted-foreground">Automated vendor check-ins, driver coordination, and staff routing</p>
                <p className="text-primary font-bold mt-2 text-sm">24/7 availability</p>
              </div>
            </div>
          </section>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">Results You Can Expect</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Clean, safe aisles reduce slip-and-fall accidents</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Meet OSHA cleanliness standards consistently</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Save $6,000–$12,000/month in janitorial labor</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Operate cleaning overnight without overtime costs</span>
              </li>
            </ul>
          </section>

          <section className="text-center">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">Scale Your Operations Safely</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-6 max-w-2xl mx-auto leading-relaxed">
              Keep your facility clean, safe, and compliant without adding headcount.
            </p>
            <Button 
              asChild
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 font-extrabold rounded-xl"
            >
              <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
                Schedule Warehouse Demo
              </a>
            </Button>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Warehouses;
